import { h, FunctionalComponent } from 'preact';

interface IAccessibilityLinkProps {
  accessibilityCompliance?: string;
  accessibilityLink?: string;
  onAccessibilityClicked: () => void;
  labels: { [key: string]: string };
}

const levels = ['none', 'partial', 'full'];

export const AccessibilityLink: FunctionalComponent<IAccessibilityLinkProps> = (props: IAccessibilityLinkProps) => {
  const { accessibilityCompliance, accessibilityLink } = props;
  if (!accessibilityCompliance || levels.indexOf(accessibilityCompliance.toLowerCase()) === -1) {
    return null;
  }
  return (
    <li>
      {
        accessibilityLink ?
          <a
            onClick={props.onAccessibilityClicked}
            href={accessibilityLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            {props.labels[accessibilityCompliance]}
          </a>
          :
          <span
            style="padding: 0 15px;"
            onClick={props.onAccessibilityClicked}
          >
            {props.labels[accessibilityCompliance]}
          </span>
      }
    </li>
  );
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/sgwt-mini-footer/components/AccessibilityLink.tsx